export const ROLE_OPTIONS = [
  {
    value: "admin",
    label: "Admin - All access, including team, billing settings",
  },
  {
    value: "staff",
    label: "Staff - All access, except team, billing settings",
  },
  { value: "agent", label: "Agent - Can only view/add referrals" },
  {
    value: "affiliate",
    label:
      "Affiliate - Can only view/add referrals, kept separate from Agents",
  },
];

export const EXTERNAL_ROLE_OPTIONS = [
  { value: "agent", label: "Agent" },
  { value: "affiliate", label: "Affiliate" },
];
